import axios from '../axiosSetup';

export async function getOrderPipeline() {
  const res = await axios.get('/customer/dashboard');
  const data = res.data;

  const stages = [
    { key: 'draft', label: 'Draft', count: data.draftOrders ?? 0, meta: 'Awaiting submission' },
    { key: 'submitted', label: 'Submitted', count: data.submittedOrders ?? 0, meta: 'Under review' },
    { key: 'approved', label: 'Approved', count: data.approvedOrders ?? 0, meta: 'Confirmed' },
    { key: 'in_transit', label: 'In Transit', count: data.intransitOrders ?? 0, meta: 'On the way' },
    { key: 'delivered', label: 'Delivered', count: data.deliveredOrders ?? 0, meta: 'Completed' },
  ];

  const offTrack = [
    { key: 'rejected', label: 'Rejected', count: data.rejectedOrders ?? 0 },
    { key: 'cancelled', label: 'Cancelled', count: data.cancelledOrders ?? 0 },
  ];

  return {
    totalOrders: data.totalOrders ?? 0,
    activeCount: (data.totalOrders ?? 0) - (data.rejectedOrders ?? 0) - (data.cancelledOrders ?? 0),
    offTrackCount: (data.rejectedOrders ?? 0) + (data.cancelledOrders ?? 0),
    windowLabel: 'Last 90 days',
    stages,
    offTrack,
  };
}

export async function getRecentOrders() {
  const res = await axios.get('/customer/dashboard/latest-orders');
  const orders = res.data;

  return orders.map((o) => ({
    id: o.id,
    poNumber: o.purchaseOrderId,
    date: o.createdAt,
    total: o.total ?? 0,
    status: o.status,
    currency: o.currency,
  }));
}

export async function getAccountSnapshot() {
  const res = await axios.get('/customer/dashboard/account-snapshot');
  const data = res.data;

  return {
    entity: data.entity ?? 'Unknown',
    customerCode: data.customerCode ?? '—',
    creditLimit: data.creditLimit ?? 0,
    creditUsed: data.creditUsed ?? 100,
    terms: data.terms ?? '—',
    nextDue: data.nextDue ?? '—',
    outstanding: data.outstanding ?? 0,
    ytdSpend: data.ytdSpend ?? 0,
    currency: data.currency ?? '$',
    currencyCode: data.currencyCode ?? data.currency ?? '',
  };
}

export async function clearAllNotifications() {
  const res = await axios.delete('/customer/notifications');
  return res.data;
}

export async function getNotifications(limit, cursor) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  const res = await axios.get('/customer/notifications', { params });
  return res.data;
}

export async function getAnnouncements() {
  const res = await axios.get('/customer/dashboard/announcements');
  return res.data;
}